export const PROGRESS_STEPS = ['校验时间', '推算干支', '排布九宫', '完成'];

export const AI_PROGRESS_STEPS = [
  '分析问题类型',
  '识别显性与隐性需求',
  '分析取用神',
  '拆解盘面象意符号',
  '推断应期与触发条件',
  '匹配知识库证据',
  '生成直断与详解结果',
];

export const AI_PROGRESS_DURATION_MS = 75000;

export const AI_FOLLOWUP_PROGRESS_STEPS = [
  '读取上一轮结论',
  '定位本次追问焦点',
  '快速复核关键盘证',
  '生成追问回复',
];

export const AI_FOLLOWUP_PROGRESS_DURATION_MS = 28000;

export const AI_INITIAL_ESTIMATE_DEFAULT_SECONDS = Math.max(1, Math.round(AI_PROGRESS_DURATION_MS / 1000));
export const AI_FOLLOWUP_ESTIMATE_DEFAULT_SECONDS = Math.max(1, Math.round(AI_FOLLOWUP_PROGRESS_DURATION_MS / 1000));
export const AI_PROGRESS_TICK_MS = 100;
export const AI_PROGRESS_MAX_WAIT_PERCENT = 96;
export const TEACHER_WECHAT_ID = 'dao6257';

export const AI_INTERPRET_NOTICE_MARKDOWN = `# 轩辕解读须知

## 一、什么是“占卜”？轩辕奇门的原理是什么？

占卜本质上是一种**时空解码技术**。

当心中有疑惑时，当下的时间与空间便承载了问题的全部信息。通过奇门遁甲这个高维数术模型，我们将这些隐形的信息“显影”为具体的符号（象），再通过解读这些“象”来获得决策的启示。

**轩辕国学AI** 是一套基于**道家阴盘奇门**心法构建的智能系统。它遵循“在天成象，在地成形”的全息对应原理，当你诚心起盘的那一刻，盘面上的神、星、门、干组合，就精准映射了你当下的处境与未来的走向。

它的作用，是代替一位深谙易理的策划师，不知疲倦地为您拆解这些复杂的符号，从局势判断到落地建议，提供客观且具象的指引。

## 二、为什么有时候会觉得“不准”？

### 1. 解读的维度
占卜是一门玄妙的技术，解读结果有难易之分，相应的准确度也有所不同：

- **最难解读**：精确的数字（如赚多少钱）、具体的应期（如哪天几点）、绝对的二元对立（是/否）。
- **次难解读**：极度复杂的量化细节（如对方的身高体重具体数值）。
- **相对容易**：**趋势判断、吉凶定性、矛盾点定位、行动建议**。

### 2. 心诚则灵
奇门遁甲乃帝王之术，讲究天时地利人和。起局的质量，在于当下的“念力”与“机缘”：

1. **不动不占**：心中无事、无强烈疑惑时，不要起局。
2. **不疑不占**：不要抱着“考考你”的心态试探。
3. **不义不占**：违背道德法律、损人利己之事，不占。
4. **不易不占**：明显无法改变的客观事实，不必占测。

### 3. 客观认知
**占卜的准确性绝非百分之百。**  
但系统可保证：  
1. 基于阴盘奇门心法构建；  
2. 推演逻辑复刻专业预测师的断局思路。

## 三、轩辕奇门的可靠性

- **取用神体系**：精准锁定人与事的时空坐标。  
- **微观象意体系**：将抽象符号翻译为现实场景。  
- **多维推演路径**：包含微象分割、组象关联、四害量化等步骤。

## 四、注意事项

1. 同一问题时局需间隔至少两小时，刻局需 10 分钟以上。  
2. 避免一卦多问。  
3. 禁止用于炒股等风险投资。  
4. 保持理性思维，内容仅供娱乐与学术交流。`;
